import classNames from 'classnames';
import React from 'react';
import styled from 'styled-components';
import {V6} from '../../theme';

export const Container = styled.div<{
  isDisplayedInProductTile: boolean;
}>`
  height: 22px;
  width: fit-content;
  display: inline-flex;
  align-items: center;
  margin-right: 5px;
  background-color: ${V6.badges.backgroundColors.default};
  color: ${V6.badges.colors.default};
  border-radius: ${({isDisplayedInProductTile}) => {
    if (isDisplayedInProductTile) {
      return '0 4px 4px 0';
    }
    return '4px';
  }};
`;

const Text = styled.p<{isDisplayedInProductTile: boolean}>`
  font-size: ${V6.badges.fontSize};
  font-weight: ${V6.badges.fontWeight};
  display: flex;
  align-items: center;
  padding: ${({isDisplayedInProductTile}) =>
    isDisplayedInProductTile ? '2px 8px 2px 16px' : '2px 8px'};

  span {
    line-height: 1em;
  }
  white-space: nowrap;
`;

const EmojiContainer = styled.span`
  padding-right: 5px;
`;

export interface BadgeProps {
  text: string;
  name: string;
  emoji?: string;
  className?: string;
  isDisplayedInProductTile: boolean;
  dataTestId?: string;
  backgroundColor?: string;
}
export const Badge: React.FC<BadgeProps> = ({
  name,
  text,
  emoji,
  className,
  isDisplayedInProductTile,
  dataTestId,
}) => (
  <Container
    data-testid={dataTestId}
    className={classNames('badge-item', name, className)}
    isDisplayedInProductTile={isDisplayedInProductTile}
  >
    <Text isDisplayedInProductTile={isDisplayedInProductTile}>
      {emoji ? <EmojiContainer role="img">{emoji}</EmojiContainer> : null}
      {text}
    </Text>
  </Container>
);
